import type { FunctionComponent } from 'react'
import ContentContainer from '../../shared/components/ContentContainer/ContentContainer'
import MarkdownParser from '../../shared/components/MarkdownParser'
import ShareBar from '../../shared/components/ShareBar/ShareBar'
import { StyledContainer, StyledRow } from '../static/styles'

interface MarkdownPageProps {
  markdownFile: string
}

const MarkdownPage: FunctionComponent<MarkdownPageProps> = ({ markdownFile }) => (
  <ContentContainer>
    <StyledContainer>
      <StyledRow>
        <MarkdownParser>{markdownFile}</MarkdownParser>
        <ShareBar />
      </StyledRow>
    </StyledContainer>
  </ContentContainer>
)

export default MarkdownPage
